import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted } from 'vue';
import { reportIndexPvUvAndTimeCost, language, CustomException } from '@tencent/ppd-base-libs';
import { useWxShare } from '@/hooks/use-wx-share';
import { userConfigStore } from '@/store';
import { to } from '@tencent/wphk-base-utils';
import { showErrorDialog } from '@tencent/wphk-act-base-ui';

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const configStore = userConfigStore();

onBeforeMount(async () => {
  // 初始化配置
  const [err] = await to(configStore.init());
  if (err) {
    showErrorDialog({
      message: '配置異常，請重試',
    });
    throw new CustomException(err, 'actInitFail', '活动初始化失败');
  }
  const { shareInfo, pageTitle } = configStore.config;
  // 微信分享初始化
  useWxShare(shareInfo);
  // 设置页面标题
  document.title = pageTitle;
});
onMounted(() => {
  reportIndexPvUvAndTimeCost();
});

return { __sfc: true,configStore, language }
}

})